type PropertyFields = {
  address: string
  total_bedrooms: number
  total_bathrooms: number
  home_square_footage: number
  lot_size: number
  structure_type_code: string
  year_built: number
  is_confirmed: boolean
  property_id: string
}

export const fieldsInPropertyDetails = [
  {
    label: 'Beds',
    path: 'total_bedrooms',
  },
  {
    label: 'Year Built',
    path: 'year_built',
  },
  {
    label: 'Baths',
    path: 'total_bathrooms',
  },
  {
    label: 'Lot Size (Acres)',
    path: 'lot_size',
  },
  {
    label: 'Square Feet',
    path: 'home_square_footage',
  },
  {
    label: 'Property Type',
    path: 'structure_type_code',
  },
]

export type PropertyBoxProps = {
  property: PropertyFields
}

// At first glance, it looks the same as the previous type, but I plan to add more fields.
// If no more fieds are added, the type definition will be simplified and some will be removed.
export type PropertyFieldsProps = {
  property: PropertyFields
}

export type AddressBoxProps = {
  address: String
  showIsConfirmed?: Boolean
}

export type ViewFieldProps = {
  label: string
  value: string | number | true
}
